(() => {
  const READY_KEY = "__beelineFindNearbyReady";
  const INIT_KEY = "__beelineFindNearbyInitialized";

  const getReadyPromise = () => {
    if (window[READY_KEY]) {
      return window[READY_KEY];
    }

    if (window.BeelineFindNearby && typeof window.BeelineFindNearby.init === "function") {
      window[READY_KEY] = Promise.resolve();
      return window[READY_KEY];
    }

    const script = document.querySelector("script[data-beeline-embed]");
    if (!script) {
      window[READY_KEY] = Promise.reject(new Error("Beeline embed script not found."));
      return window[READY_KEY];
    }

    window[READY_KEY] = new Promise((resolve, reject) => {
      script.addEventListener("load", resolve, { once: true });
      script.addEventListener("error", () => reject(new Error("Beeline embed failed to load.")), { once: true });
    });

    return window[READY_KEY];
  };

  const ensureInitialized = async () => {
    await getReadyPromise();
    if (!window[INIT_KEY]) {
      window.BeelineFindNearby.init();
      window[INIT_KEY] = true;
    }
  };

  const getActiveVariantId = (form, fallbackId) => {
    if (form) {
      const input = form.querySelector('input[name="id"]');
      if (input && input.value) {
        return parseInt(input.value, 10);
      }
    }

    const params = new URLSearchParams(window.location.search);
    const paramVariant = params.get("variant");
    if (paramVariant) {
      return parseInt(paramVariant, 10);
    }

    return fallbackId;
  };

  const updateButtonState = (button, barcode) => {
    if (barcode) {
      button.hidden = false;
    } else {
      button.hidden = true;
    }
  };

  const adjustIframe = () => {
    const header = document.querySelector("#shopify-section-header .header__wrapper")
      || document.querySelector("#shopify-section-header");
    const iframeWrapper = document.getElementById("beeline-find-nearby-iframe-wrapper");

    if (!iframeWrapper) {
      return;
    }

    if (header) {
      iframeWrapper.style.top = `${header.offsetHeight}px`;
    }

    iframeWrapper.style.height = "100%";
  };

  const showBeeline = async (barcode, position) => {
    if (!barcode) {
      return;
    }

    await ensureInitialized();
    window.BeelineFindNearby.show(barcode, position || "right");
    adjustIframe();
  };

  class CustomBeelineFindNearby extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.variantChangeHandler = null;
    }

    connectedCallback() {
      // Clean up any existing listeners
      this.disconnectedCallback();

      // Initialize abort controller for cleanup
      this.abortController = new AbortController();

      // Use requestAnimationFrame to ensure DOM is ready
      requestAnimationFrame(() => {
        this.init();
      });
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
      if (this.variantChangeHandler) {
        const formId = this.dataset.productFormId;
        const form = formId ? document.getElementById(formId) : null;
        if (form && this.variantChangeHandler) {
          form.removeEventListener("variant:change", this.variantChangeHandler);
        }
        this.variantChangeHandler = null;
      }
    }

    init() {
      const dataEl = this.querySelector("[data-beeline-variants]");
      const trigger = this.querySelector("[data-beeline-trigger]");
      if (!dataEl || !trigger) {
        return;
      }

      let variants = [];
      try {
        variants = JSON.parse(dataEl.textContent || "[]");
      } catch (error) {
        return;
      }

      const variantMap = new Map(
        variants.map((variant) => [parseInt(variant.id, 10), variant.barcode])
      );

      const formId = this.dataset.productFormId;
      const form = formId ? document.getElementById(formId) : null;
      const fallbackId = variants.length ? parseInt(variants[0].id, 10) : null;

      const updateActiveBarcode = (variantId) => {
        const barcode = variantMap.get(variantId);
        this.dataset.activeBarcode = barcode || "";
        updateButtonState(trigger, barcode);
      };

      updateActiveBarcode(getActiveVariantId(form, fallbackId));

      if (form) {
        this.variantChangeHandler = (event) => {
          const variant = event.detail && event.detail.variant;
          if (variant && variant.id) {
            updateActiveBarcode(parseInt(variant.id, 10));
          }
        };
        form.addEventListener("variant:change", this.variantChangeHandler, {
          signal: this.abortController.signal
        });
      }

      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        showBeeline(this.dataset.activeBarcode, this.dataset.beelinePosition);
      }, { signal: this.abortController.signal });
    }
  }

  if (!customElements.get("custom-beeline-find-nearby")) {
    customElements.define("custom-beeline-find-nearby", CustomBeelineFindNearby);
  }
})();
